import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import theme from 'theme/theme';

const Fieldset = styled.fieldset`
  clear: both;
  position: relative;
  margin: 0 0 1.5rem 0;
  padding: 0.5rem 0 1rem 0;
  border: 0;
  border-top: 2px solid ${theme.colors.primary};
  min-width: 0;
  background: transparent;
  
  ${(props) => props.isNested && css`
    padding: 0.3rem 0 0 0;
    margin: 1rem 0 1.5rem 0;
    border-top: 2px solid ${theme.colors.mediumLight};
    legend {
      font-size: ${theme.fontSizes.default};
    }
  `}
`;
Fieldset.propTypes = {
  isNested: PropTypes.bool,
};
Fieldset.defaultProps = {
  isNested: false,
};


export default Fieldset;
